import Vue from 'vue';
import VueRouter from 'vue-router';
import ROUTES_NAMES from '@/constants/ROUTES_NAMES';
import routes from '@/routes/routes';
import store from '@/store';
import { isAllowed } from '@/services/AuthService';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (store.getters['account/token']) {
    if (new Date().getTime() > store.getters['account/expiration']) {
      store.commit('clear'); // We need to clear because we need a new token

      Vue.prototype.$notifications.notify({
        message:
          'Votre session a expiré et vous avez été redirigé sur la partie publique, veuillez vous reconnecter.',
        title: 'Session expirée',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: 'warning',
        timeout: 5000,
      });
    }
  }

  if (!store.getters['account/token']) {
    try {
      await store.dispatch('account/login');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Shib session is not available', error);
      // Ignore, as we are not authentified
    }
  }

  if (isAllowed(to)) {
    return next();
  }

  // Redirect the user to the committees page if it tried to access the home page by being not allowed
  // (for example if it is disconnected or doesn't have a sufficient role).
  if (to.name === ROUTES_NAMES.OVERVIEW) {
    return next({
      name: ROUTES_NAMES.COMMITTEES,
    });
  }

  // Otherwise redirect it to the login page.
  window.location = `${process.env.VUE_APP_LOGIN_URL}?appURL=${window.location.href}`;

  return next();
});

export default router;
